import 'common/css/app.css'
import './index.css'
import 'common/js/global.js'


$(function () {
  Affix()
  var detail1 = {
    list: [
    {dt: '产品结构及安装尺寸',dd: [{name: '机身尺寸', value: '260*460*97mm(W*H*D)'},{name: '安装方式', value: '壁挂安装'}]},
    {dt: '系统保护功能参数',dd: [{name: '防雷功能', value: '板载'},{name: '安全防护', value: '过压、欠压、输出短路、漏电保护、空载断电、充满断电'},{name: '充电连接器寿命', value: '≥10000次'}]},
    {dt: '系统电气与设备基本参数',dd: [
    {name: '输入电压', value: 'AC220V±15%'},
    {name: '输出电压', value: 'AC220V±15%'},
    {name: '频率', value: '50±1Hz'},
    {name: '额定电流', value: '7kW（CH1~CH3：1.2kW，CH4~CH10：0.5kW，可定制）'},
    {name: '显示屏', value: '指示灯'},
    {name: '上位机通讯', value: '以太网/4G（选配）'},
    {name: '充电接口', value: '国标5孔插座'},
    {name: '充电模式', value: '自动充满、定时间'},
    {name: '启动方式', value: '刷IC卡、扫二维码（需接入平台及手机APP支持）'},
    {name: '电能计量', value: '2.0级'},
    {name: '防护等级', value: 'IP54（桩体）'},
    {name: '运行温度', value: '－20℃~＋50℃'},
    {name: '存储温度', value: '－40℃~＋70℃'},
    {name: '相对湿度', value: '5%~95%'},
    {name: '海拔高度', value: '≤2000m，特殊地区使用时，需根据当地环境条件在订货时说明'}
    ]},
    ]
  }
  var detail2 = {
    list: [
    {dt: '产品结构及安装尺寸',dd: [{name: '机身尺寸', value: '265.5*387.5*77.8mm(W*H*D)'},{name: '安装方式', value: '壁挂安装或选配立柱组件实现落地安装'}]},
    {dt: '系统保护功能参数',dd: [{name: '防雷功能', value: '板载'},{name: '安全防护', value: '过压、欠压、输出短路、过热、漏电保护'},{name: '充电连接器寿命', value: '≥10000次'}]},
    {dt: '系统电气与设备基本参数',dd: [
    {name: '输入电压', value: 'AC220V±15%'},
    {name: '输出电压', value: 'AC220V±15%'},
    {name: '频率', value: '50±1 HZ'},
    {name: '额定电流', value: '16A 32A'},
    {name: '显示屏', value: '指示灯/3.5吋液晶显示屏（选配）'},
    {name: '上位机通讯', value: '以太网/4G（选配）'},
    {name: '充电接口', value: '充电枪*1(符合《GB/T20234-2015》标准)'},
    {name: '充电模式', value: '自动充满（本地），定时间、定电量、定金额（在线'},
    {name: '启动方式', value: '刷IC卡、扫二维码（需接入平台及手机APP支持）'},
    {name: '电能计量', value: '1.0级（符合电网计量标准）'},
    {name: '防护等级', value: 'IP54'},
    {name: '运行温度', value: '－20℃~＋50℃'},
    {name: '存储温度', value: '－40℃~＋70℃'},
    {name: '相对湿度', value: '5%~95%'},
    {name: '海拔高度', value: '≤2000m，特殊地区使用时，需根据当地环境条件在订货时说明'}
    ]},
    ]
  }
  var detail3 = {
    list: [
    {dt: '产品结构及安装尺寸',dd: [{name: '机身尺寸', value: '充电终端：265.5*387.5*77.8mm(W*H*D);操作终端：523*1901.6*239.7mm(W*H*D)'},{name: '安装方式', value: '壁挂安装或选配立柱组件实现落地安装'}]},
    {dt: '系统保护功能参数',dd: [{name: '防雷功能', value: '板载'},{name: '安全防护', value: '过压、欠压、输出短路、过热、漏电保护'},{name: '充电连接器寿命', value: '≥10000次'}]},
    {dt: '系统电气与设备基本参数',dd: [
    {name: '输入电压', value: 'AC220V±15%'},
    {name: '输出电压', value: 'AC220V±15%'},
    {name: '频率', value: '50±1 HZ'},
    {name: '额定电流', value: '16A 32A'},
    {name: '显示屏', value: '指示灯/32吋显示屏（选配）'},
    {name: '上位机通讯', value: '以太网/4G（选配）'},
    {name: '充电接口', value: '充电枪*1(符合《GB/T20234-2015》标准)'},
    {name: '充电模式', value: '自动充满'},
    {name: '启动方式', value: '刷卡、扫二维码（需接入平台入手机APP支持）'},
    {name: '电能计量', value: '1.0级'},
    {name: '防护等级', value: 'IP54'},
    {name: '运行温度', value: '－20℃~＋50℃'},
    {name: '存储温度', value: '－40℃~＋70℃'},
    {name: '相对湿度', value: '5%~95%'},
    {name: '海拔高度', value: '≤2000m，特殊地区使用时，需根据当地环境条件在订货时说明'}
    ]},
    ]
  }
  var detail4 = {
    list: [
    {dt: '产品结构及安装尺寸',dd: [{name: '机身尺寸', value: '400*260*145mm（H*W*D）'},{name: '安装方式', value: '壁挂安装或选配立柱组件实现落地安装'}]},
    {dt: '系统保护功能参数',dd: [{name: '防雷功能', value: 'C级防雷器'},{name: '安全防护', value: '过压、欠压、输出短路、过热、漏电保护'},{name: '充电连接器寿命', value: '≥10000次'}]},
    {dt: '系统电气与设备基本参数',dd: [
    {name: '输入电压', value: 'AC220V±15%'},
    {name: '输出电压', value: 'AC220V±15%'},
    {name: '频率', value: '50±1 HZ'},
    {name: '额定电流', value: '16A 32A'},
    {name: '显示屏', value: '4.3吋彩色液晶显示屏'},
    {name: '上位机通讯', value: '以太网/4G（选配）'},
    {name: '充电接口', value: '充电枪*1(符合《GB/T20234-2015》标准)'},
    {name: '充电模式', value: '自动充满（本地），定时间、定电量、定金额（在线）'},
    {name: '启动方式', value: '刷IC卡、扫二维码（需接入平台入手机APP支持）'},
    {name: '电能计量', value: '1.0级'},
    {name: '防护等级', value: 'IP54'},
    {name: '运行温度', value: '－20℃~＋50℃'},
    {name: '存储温度', value: '－40℃~＋70℃'},
    {name: '相对湿度', value: '5%~95%'},
    {name: '海拔高度', value: '≤2000m，特殊地区使用时，需根据当地环境条件在订货时说明'}
    ]},
    ]
  }
  var detail5 = {
    list: [
      {dt: '产品结构及安装尺寸',dd: [{name: '机身尺寸', value: '450*1600*260mm(W*H*D)'},{name: '安装方式', value: '落地安装'}]},
      {dt: '系统保护功能参数',dd: [{name: '防雷功能', value: 'C级'},{name: '安全防护', value: '过压、欠压、输出短路、过热、漏电保护'},{name: '充电连接器寿命', value: '≥10000次'}]},
      {dt: '系统电气与设备基本参数',dd: [
      {name: '输入电压', value: 'AC220V±15%   AC380V±15%'},
      {name: '输出电压', value: 'AC220V±15%   AC380V±15%'},
      {name: '频率', value: '50±1 HZ'},
      {name: '额定电流', value: '10A、16A、32A   16A、32A、63A'},
      {name: '显示屏', value: '7吋触摸显示屏'},
      {name: '上位机通讯', value: '以太网/4G（选配）'},
      {name: '充电接口', value: '充电枪×2(符合《GB/T20234-2015》标准)'},
      {name: '充电模式', value: '自动充满、按时间、按电量、按金额等'},
      {name: '启动方式', value: '刷IC卡、扫二维码（需接入平台入手机APP支持）'},
      {name: '电能计量', value: '1.0级'},
      {name: '防护等级', value: 'IP54'},
      {name: '运行温度', value: '－20℃~＋50℃'},
      {name: '存储温度', value: '－40℃~＋70℃'},
      {name: '相对湿度', value: '5%~95%'},
      {name: '海拔高度', value: '≤2000m，特殊地区使用时，需根据当地环境条件在订货时说明'}
      ]},
    ]
  }
  var detail6 = {
    list: [
      {dt: '产品结构及安装尺寸',dd: [{name: '机身尺寸', value: '340*1500*200mm(W*H*D)'},{name: '安装方式', value: '落地安装'}]},
      {dt: '系统保护功能参数',dd: [{name: '防雷功能', value: 'C级'},{name: '安全防护', value: '过压、欠压、输出短路、过热、漏电保护'},{name: '充电连接器寿命', value: '≥10000次'}]},
      {dt: '系统电气与设备基本参数',dd: [
      {name: '输入电压', value: 'AC220V±15%   AC380V±15%'},
      {name: '输出电压', value: 'AC220V±15%   AC380V±15%'},
      {name: '频率', value: '50±1 HZ'},
      {name: '额定电流', value: '10A、16A、32A   16A、32A、63A'},
      {name: '显示屏', value: '7吋触摸显示屏'},
      {name: '上位机通讯', value: '以太网/4G（选配）'},
      {name: '充电接口', value: '充电枪(符合《GB/T20234-2015》标准)'},
      {name: '充电模式', value: '自动充满、按时间、按电量、按金额等'},
      {name: '启动方式', value: '刷IC卡、扫二维码（需接入平台入手机APP支持）'},
      {name: '电能计量', value: '1.0级'},
      {name: '防护等级', value: 'IP54'},
      {name: '运行温度', value: '－20℃~＋50℃'},
      {name: '存储温度', value: '－40℃~＋70℃'},
      {name: '相对湿度', value: '5%~95%'},
      {name: '海拔高度', value: '≤2000m，特殊地区使用时，需根据当地环境条件在订货时说明'}
      ]},
    ]
  }
  var detail7 = {
    list: [
      {dt: '产品结构及安装尺寸',dd: [{name: '机身尺寸', value: '450*650*258.5mm(W*H*D)'}]},
      {dt: '系统电气与设备基本参数',dd: [
      {name: '输入电压', value: 'AC380V±15%'},
      {name: '输出电压范围', value: 'I：DC200~500V,Ⅱ:DC200~750V'},
      {name: '额定电流', value: '40A   26.6A'},
      {name: '最大输出电流', value: '50A   50A'},
      {name: '功率因数', value: '≥0.99'},
      {name: '电压误差', value: '≤±0.5%'},
      {name: '稳流精度', value: '≤±1%'},
      {name: '谐波含量', value: '≤4%'},
      {name: '稳压精度', value: '≤±0.5%'},
      {name: '绝缘电阻', value: '≥10MΩ'},
      {name: '功率输出模式', value: '单枪'},
      {name: '显示屏', value: '7吋触摸显示屏'},
      {name: '上位机通讯', value: '以太网/4G（选配）'},
      {name: '充电接口', value: '充电枪*1(符合《GB/T20234-2015》标准)'},
      {name: '充电模式', value: '自动充满、按时间、按电量、按金额等'},
      {name: '启动方式', value: '刷IC卡、扫二维码（需接入平台及手机APP支持）'},
      {name: '电能计量', value: '1.0级（符合电网计量标准）'},
      {name: '防护等级', value: 'IP54'},
      {name: '运行温度', value: '－20℃~＋50℃'},
      {name: '存储温度', value: '－40℃~＋70℃'},
      {name: '相对湿度', value: '5%~95%'},
      {name: '海拔高度', value: '≤2000m，特殊地区使用时，需根据当地环境条件在订货时说明'}
      ]},
    ]
  }
  var detail8 = {
    list: [
      {dt: '产品结构及安装尺寸',dd: [{name: '机身尺寸', value: '750*1700*450mm(W*H*D)'}]},
      {dt: '系统电气与设备基本参数',dd: [
      {name: '额定输出功率', value: '30kW  40kW 60kW'},
      {name: '输出电压范围', value: 'I：DC200~500V   Ⅱ:DC200~750V'},    
      {name: '输入电压', value: 'AC380V±15%'},
      {name: '输出电压范围', value: 'I Ⅱ I Ⅱ I Ⅱ'},
      {name: '额定电流', value: '60A  40A  80A  53.3A  120A  80A'},
      {name: '最大输出电流', value: '75A  75A  100A  100A  150A  150A'},
      {name: '功率因数', value: '≥0.99'},
      {name: '电压误差', value: '≤±0.5%'},
      {name: '稳流精度', value: '≤±1%'},
      {name: '谐波含量', value: '≤4%'},
      {name: '稳压精度', value: '≤±0.5%'},
      {name: '绝缘电阻', value: '≥10MΩ'},
      {name: '效率', value: '≥95%'},
      {name: '显示屏', value: '7吋触摸显示屏'},
      {name: '上位机通讯', value: '以太网/4G（选配）'},
      {name: '充电接口', value: '充电枪*1(符合《GB/T20234-2015》标准)'},
      {name: '充电模式', value: '自动充满、按时间、按电量、按金额等'},
      {name: '启动方式', value: '刷IC卡、扫二维码（需接入平台及手机APP支持）'},
      {name: '电能计量', value: '1.0级（符合电网计量标准）'},
      {name: '防护等级', value: 'IP54'},
      {name: '运行温度', value: '－20℃~＋50℃'},
      {name: '存储温度', value: '－40℃~＋70℃'},
      {name: '相对湿度', value: '5%~95%'},
      {name: '海拔高度', value: '≤2000m，特殊地区使用时，需根据当地环境条件在订货时说明'}
      ]},
    ]
  }

  // 80-120kW 150-180kW一体双枪 240-360kW一体双枪
  var detail10 = {
    list: [
      {dt: '产品结构及安装尺寸',dd: [{name: '机身尺寸', value: '750*1700*650mm(W*H*D)'}]},
      {dt: '系统电气与设备基本参数',dd: [
      {name: '额定输出功率', value: '80kW 120kW'},
      {name: '输入电压', value: 'AC380V±15%'},
      {name: '输出电压范围', value: 'DC200~750V'},
      {name: '额定电流', value: '106A 160A'},
      {name: '最大输出电流', value: '200A 300A（单枪最大250A）'},
      {name: '功率因数', value: '≥0.99'},
      {name: '电压误差', value: '≤±0.5%'},
      {name: '稳流精度', value: '≤±1%'},
      {name: '谐波含量', value: '≤4%'},
      {name: '稳压精度', value: '≤±0.5%'},
      {name: '绝缘电阻', value: '≥10MΩ'},
      {name: '效率', value: '≥95%'},
      {name: '显示屏', value: '7吋触摸显示屏'},
      {name: '上位机通讯', value: '以太网/4G（选配）'},
      {name: '充电接口', value: '充电枪*2(符合《GB/T20234-2015》标准)'},
      {name: '充电模式', value: '自动充满、按时间、按电量、按金额等'},
      {name: '启动方式', value: '刷IC卡、扫二维码（需接入平台及手机APP支持）'},
      {name: '电能计量', value: '1.0级（符合电网计量标准）'},
      {name: '防护等级', value: 'IP54'},
      {name: '运行温度', value: '－20℃~＋50℃'},
      {name: '存储温度', value: '－40℃~＋70℃'},
      {name: '相对湿度', value: '5%~95%'},
      {name: '海拔高度', value: '≤2000m，特殊地区使用时，需根据当地环境条件在订货时说明'}
      ]},
    ]
  }
  var detail11 = {
    list: [
      {dt: '产品结构及安装尺寸',dd: [{name: '机身尺寸', value: '800*1800*650mm(W*H*D)'}]},
      {dt: '系统电气与设备基本参数',dd: [
      {name: '额定输出功率', value: '150kW   180kW'},
      {name: '输入电压', value: 'AC380V±15%'},
      {name: '输出电压范围', value: 'DC200~750V'},
      {name: '额定电流', value: '200A   240A'},
      {name: '最大输出电流', value: '375A（单枪最大250A） 450A（单枪最大250A）'},
      {name: '功率因数', value: '≥0.99'},
      {name: '电压误差', value: '≤±0.5%'},
      {name: '稳流精度', value: '≤±1%'},
      {name: '谐波含量', value: '≤4%'},
      {name: '稳压精度', value: '≤±0.5%'},
      {name: '绝缘电阻', value: '≥10MΩ'},
      {name: '效率', value: '≥95%'},
      {name: '显示屏', value: '7吋触摸显示屏'},
      {name: '上位机通讯', value: '以太网/4G（选配）'},
      {name: '充电接口', value: '充电枪*2(符合《GB/T20234-2015》标准)'},
      {name: '功率输出模式', value: '单枪、双枪功率自动分配'},
      {name: '充电模式', value: '自动充满、按时间、按电量、按金额等'},
      {name: '启动方式', value: '刷IC卡、扫二维码（需接入平台及手机APP支持）'},
      {name: '电能计量', value: '1.0级（符合电网计量标准）'},
      {name: '防护等级', value: 'IP54'},
      {name: '运行温度', value: '－20℃~＋50℃'},
      {name: '存储温度', value: '－40℃~＋70℃'},
      {name: '相对湿度', value: '5%~95%'},
      {name: '海拔高度', value: '≤2000m，特殊地区使用时，需根据当地环境条件在订货时说明'}
      ]},
    ]
  }
  var detail12 = {
    list: [
      {dt: '产品结构及安装尺寸',dd: [{name: '机身尺寸', value: '850*1800*950mm(W*H*D)'}]},
      {dt: '系统电气与设备基本参数',dd: [
      {name: '额定输出功率', value: '240kW  300kW 360kW'},
      {name: '输入电压', value: 'AC380V±15%'},
      {name: '输出电压范围', value: 'DC200~750V'},
      {name: '额定电流', value: '320A   400A   480A'},
      {name: '最大输出电流', value: '396A（单枪最大250A）495A（单枪最大250A）500A（单枪最大250A）'},
      {name: '功率因数', value: '≥0.99'},
      {name: '电压误差', value: '≤±0.5%'},
      {name: '稳流精度', value: '≤±1%'},
      {name: '谐波含量', value: '≤4%'},
      {name: '稳压精度', value: '≤±0.5%'},
      {name: '绝缘电阻', value: '≥10MΩ'},
      {name: '效率', value: '≥95%'},
      {name: '显示屏', value: '7吋触摸显示屏'},
      {name: '上位机通讯', value: '以太网/4G（选配）'},
      {name: '充电接口', value: '充电枪*2(符合《GB/T20234-2015》标准)'},
      {name: '功率输出模式', value: '独立充电+均分充电、功率自动分配、双枪同充一车'},
      {name: '充电模式', value: '自动充满、按时间、按电量、按金额等'},
      {name: '启动方式', value: '刷IC卡、扫二维码（需接入平台及手机APP支持）'},
      {name: '电能计量', value: '1.0级（符合电网计量标准）'},
      {name: '防护等级', value: 'IP54'},
      {name: '运行温度', value: '－20℃~＋50℃'},
      {name: '存储温度', value: '－40℃~＋70℃'},
      {name: '相对湿度', value: '5%~95%'},
      {name: '海拔高度', value: '≤2000m，特殊地区使用时，需根据当地环境条件在订货时说明'}
      ]},
    ]
  }
  var detail13 = {
    list: [
      {dt: '产品结构及安装尺寸',dd: [{name: '机身尺寸', value: '800*1800*750mm(W*H*D)'}]},
      {dt: '系统电气与设备基本参数',dd: [
      {name: '额定输出功率', value: '120kW  180kW'},
      {name: '输入电压', value: 'AC380V±15%'},
      {name: '输出电压范围', value: 'DC200~750V'},
      {name: '额定电流', value: '160A   240A'},
      {name: '最大输出电流', value: '300A（单枪最大250A）  450A（单枪最大250A）'},
      {name: '功率因数', value: '≥0.99'},
      {name: '电压误差', value: '≤±0.5%'},
      {name: '稳流精度', value: '≤±1%'},
      {name: '谐波含量', value: '≤4%'},
      {name: '稳压精度', value: '≤±0.5%'},
      {name: '绝缘电阻', value: '≥10MΩ'},
      {name: '效率', value: '≥95%'},
      {name: '显示屏', value: '7吋触摸显示屏'},
      {name: '上位机通讯', value: '以太网/4G（选配）'},
      {name: '充电接口', value: '充电枪*4(符合《GB/T20234-2015》标准)'},
      {name: '功率输出模式', value: '独立充电+均分充电、功率自动分配'},
      {name: '充电模式', value: '自动充满、按时间、按电量、按金额等'},
      {name: '启动方式', value: '刷IC卡、扫二维码（需接入平台及手机APP支持）'},
      {name: '电能计量', value: '1.0级（符合电网计量标准）'},
      {name: '防护等级', value: 'IP54'},
      {name: '运行温度', value: '－20℃~＋50℃'},
      {name: '存储温度', value: '－40℃~＋70℃'},
      {name: '相对湿度', value: '5%~95%'},
      {name: '海拔高度', value: '≤2000m，特殊地区使用时，需根据当地环境条件在订货时说明'}
      ]},
    ]
  }
  var detail14 = {
    list: [
      {dt: '产品结构及安装尺寸',dd: [{name: '机身尺寸', value: '850*1800*850mm(W*H*D)'}]},
      {dt: '系统电气与设备基本参数',dd: [
      {name: '额定输出功率', value: '240kW'},
      {name: '输入电压', value: 'AC380V±15%'},
      {name: '输出电压范围', value: 'DC200~750V'},
      {name: '额定电流', value: '320A'},
      {name: '最大输出电流', value: '600A（单枪最大250A）'},
      {name: '功率因数', value: '≥0.99'},
      {name: '电压误差', value: '≤±0.5%'},
      {name: '稳流精度', value: '≤±0.5%'},
      {name: '谐波含量', value: '≤4%'},
      {name: '稳压精度', value: '≤±1%'},
      {name: '绝缘电阻', value: '≥10MΩ'},
      {name: '效率', value: '≥95%'},
      {name: '显示屏', value: '7吋触摸显示屏'},
      {name: '上位机通讯', value: '以太网/4G（选配）'},
      {name: '充电接口', value: '充电枪*4(符合《GB/T20234-2015》标准)'},
      {name: '功率输出模式', value: '独立充电+均分充电、功率自动分配'},
      {name: '充电模式', value: '自动充满、按时间、按电量、按金额等'},
      {name: '启动方式', value: '刷IC卡、扫二维码（需接入平台及手机APP支持）'},
      {name: '电能计量', value: '1.0级（符合电网计量标准）'},
      {name: '防护等级', value: 'IP54'},
      {name: '运行温度', value: '－20℃~＋50℃'},
      {name: '存储温度', value: '－40℃~＋70℃'},
      {name: '相对湿度', value: '5%~95%'},
      {name: '海拔高度', value: '≤2000m，特殊地区使用时，需根据当地环境条件在订货时说明'}
      ]},
    ]
  }
  var detail15 = {
    list: [
      {dt: '产品结构及安装尺寸',dd: [{name: '机身尺寸', value: '1450*2000*900mm(W*H*D)'}]},
      {dt: '系统电气与设备基本参数',dd: [
      {name: '额定输出功率', value: '360kW'},
      {name: '输入电压', value: 'AC380V±15%'},
      {name: '输出电压范围', value: 'DC200~750V'},
      {name: '额定电流', value: '480A'},
      {name: '最大输出电流', value: '900A（单枪最大250A）'},
      {name: '功率因数', value: '≥0.99'},
      {name: '电压误差', value: '≤±0.5%'},
      {name: '稳流精度', value: '≤±0.5%'},
      {name: '谐波含量', value: '≤4%'},
      {name: '稳压精度', value: '≤±1%'},
      {name: '绝缘电阻', value: '≥10MΩ'},
      {name: '效率', value: '≥95%'},
      {name: '显示屏', value: '7吋触摸显示屏'},
      {name: '上位机通讯', value: '以太网/4G（选配）'},
      {name: '充电接口', value: '充电枪*4(符合《GB/T20234-2015》标准)'},
      {name: '功率输出模式', value: '独立充电+均分充电、功率自动分配'},
      {name: '充电模式', value: '自动充满、按时间、按电量、按金额等'},
      {name: '启动方式', value: '刷IC卡、扫二维码（需接入平台及手机APP支持）'},
      {name: '电能计量', value: '1.0级（符合电网计量标准）'},
      {name: '防护等级', value: 'IP54'},
      {name: '运行温度', value: '－20℃~＋50℃'},
      {name: '存储温度', value: '－40℃~＋70℃'},
      {name: '相对湿度', value: '5%~95%'},
      {name: '海拔高度', value: '≤2000m，特殊地区使用时，需根据当地环境条件在订货时说明'}
      ]},
    ]
  }
  var detail16 = {
    list: [
      {dt: '产品结构及安装尺寸',dd: [{name: '机身尺寸', value: ' 整流柜：900*2000*800mm(W*H*D);控制柜：1400*2000*800mm(W*H*D);充电终端：500*1600*260mm(W*H*D)'}]},
      {dt: '系统电气与设备基本参数',dd: [
      {name: '额定输出功率', value: '360~480kW可选'},
      {name: '输入电压', value: 'AC380V±15%'},
      {name: '输出电压范围', value: 'DC200~750V'},
      {name: '额定电流', value: '640A'},
      {name: '最大输出电流', value: '1200A（单枪最大250A）'},
      {name: '功率因数', value: '≥0.99'},
      {name: '电压误差', value: '≤±0.5%'},
      {name: '稳流精度', value: '≤±0.5%'},
      {name: '谐波含量', value: '≤4%'},
      {name: '稳压精度', value: '≤±1%'},
      {name: '绝缘电阻', value: '≥10MΩ'},
      {name: '效率', value: '≥95%'},
      {name: '显示屏', value: '7吋触摸显示屏'},
      {name: '上位机通讯', value: '以太网/4G（选配）'},
      {name: '充电接口', value: '功率分配柜10路输出;充电枪*1或*2(符合《GB/T20234-2015》标准);5~10个终端可选配'},
      {name: '功率输出模式', value: '多枪功率自动分配'},
      {name: '充电模式', value: '自动充满、按时间、按电量、按金额等'},
      {name: '启动方式', value: '刷IC卡、扫二维码（需接入平台及手机APP支持）'},
      {name: '电能计量', value: '1.0级（符合电网计量标准）'},
      {name: '防护等级', value: 'IP54'},
      {name: '运行温度', value: '－20℃~＋50℃'},
      {name: '存储温度', value: '－40℃~＋70℃'},
      {name: '相对湿度', value: '5%~95%'},
      {name: '海拔高度', value: '≤2000m，特殊地区使用时，需根据当地环境条件在订货时说明'}
      ]},
    ]
  }
  var detail9 = {
    list: [
      {dt: '产品结构及安装尺寸',dd: [{name: '机身尺寸', value: ' 整流柜：1600*750*800  1895*750*800  1900*900*900  2000*930*800;终端：1600*500*260（H*W*D，mm）（单枪） 1600*500*260（H*W*D，mm）（双枪）'}]},
      {dt: '系统电气与设备基本参数',dd: [
      {name: '输入电压', value: 'AC380V±20%'},
      {name: '输出电压范围', value: 'DC200~750V'},
      {name: '额定电流', value: '200A     300A     400A     600A'},
      {name: '最大输出电流', value: '240A     360A     480A     720A'},
      {name: '功率因数', value: '≥0.99'},
      {name: '电压误差', value: '≤±0.5%'},
      {name: '稳流精度', value: '≤±1%'},
      {name: '谐波含量', value: '≤4%'},
      {name: '稳压精度', value: '≤±0.5%'},
      {name: '绝缘电阻', value: '≥10MΩ'},
      {name: '漏电电流', value: '＜3.5mA'},
      {name: '效率', value: '≥95%'},
      {name: '显示屏', value: '7吋触摸显示屏'},
      {name: '上位机通讯', value: '以太网/GPRS（选配）/4G（选配）'},
      {name: '充电接口', value: '充电枪×4（符合GB/T20234-2015标准）'},
      {name: '功率输出模式', value: '独立充电+均分充电     、功率自动分配(可选)'},
      {name: '充电模式', value: '自动充满、按时间、按电量、按金额等'},
      {name: '启动方式', value: '刷IC卡、扫二维码（需接入平台及手机APP支持）'},
      {name: '电能计量', value: '交流侧0.5S级，直流侧1.0级（符合电网计量标准）'},
      {name: '防护等级', value: 'IP54'},
      {name: '运行温度', value: '－25℃~＋55℃'},
      {name: '存储温度', value: '－40℃~＋70℃'},
      {name: '相对湿度', value: '5%~95%'},
      {name: '海拔高度', value: '≤2000m，特殊地区使用时，需根据当地环境条件在订货时说明'}
      ]},
    ]
  }
  var detail17 = {
    list: [
      {dt: '产品结构及安装尺寸',dd: [{name: '机身尺寸', value: '385mm*110mm*395mm(W*H*D)'}]},
      {dt: '系统电气与设备基本参数',dd: [
      {name: '额定电流', value: '30A'},
      {name: '稳压精度', value: '≤±0.5%'},
      {name: '稳流精度', value: '≤±1%'},
      {name: '功率因数', value: '≥0.90'},
      {name: '负载调整率', value: '≥0.99'},
      {name: '效率', value: '≥95%'},
      {name: '工作温度', value: '-40℃~+75℃'},
      {name: '存储温度', value: '－40℃~＋70℃'},
      {name: '大气压力', value: '79kPa~106kPa'},
      {name: '直流输出电压范围', value: '150Vac~1000Vac'},
      {name: '直流输出电流范围', value: '0~100A(限流点可以设)'},
      {name: '额定电压', value: '380Vac'},
      {name: '最大电流', value: '100A'}
      ]},
    ]
  }
 var makeDetailDom =  function (val, value) {
    let name = "#" + value 
    $('#electric-product-detail').css('display','block')
    $('#electric-product-wrapper').css('display','none')
  //  要将详情清空，重新生成
    $('#electric-product-detail').empty()
    // 生成详情头部DOM
    let deatailHeader = $("<div class='deatail-header'><a href="+ name +"><div class='back-list PC-img' id='PC-back'>← 返回列表</div></a><a href="+ name +"><div class='back-icon phone-img' id='phone-back'> < </div></a></div>")
    $('#electric-product-detail').append(deatailHeader)
    // 生成详情列表DOM
    let detailContent = $("<div class='detail-content'><h1>技术参数</h1></div>")
    val.list.forEach(item => {
      let dl = $("<dl></dl>")
      let dt = $("<dt>"+ item.dt +"</dt>")
      let dd = $("<dd></dd>")
      item.dd.forEach(it => {
        let div = $("<div class='row'><span class='name'>"+ it.name +"</span><span class='value'>"+ it.value +"</span></div>")
        dd.append(div)
      })
      dl.append(dt)
      dl.append(dd)
      detailContent.append(dl)
    })
    $('#electric-product-detail').append(detailContent)
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

  // PC点击返回按钮，返回到电桩主页面
  $('#electric-product-detail').on('click', '#PC-back',function () {
    $('#electric-product-detail').css('display','none')
    $('#electric-product-wrapper').css('display','block')
    
  })
  // 手机点击返回按钮，返回到电桩主页面
  $('#electric-product-detail').on('click','#phone-back', function () {
    $('#electric-product-detail').css('display','none')
    $('#electric-product-wrapper').css('display','block')
  })
  // 点击查看详情
  window.checkDetail= function(val){
    makeDetailDom (eval(val), val)
  }
})
function Affix() {
  var affixTop = $("#electric-product-wrapper .offsetTop").offset().top
  $('#affixBox').affix({
    offset: {
      top: affixTop
    }
  })
}



// WEBPACK FOOTER //
// ./src/electricProduct/index.js